import { render } from "./ViewKeputusanPSB.vue?vue&type=template&id=2f58aedf"
import script from "./ViewKeputusanPSB.vue?vue&type=script&lang=js"
export * from "./ViewKeputusanPSB.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__